import { render, staticRenderFns } from "./UploadArrayCheckboxList.vue?vue&type=template&id=332dac4c"
import script from "./UploadArrayCheckboxList.vue?vue&type=script&lang=js"
export * from "./UploadArrayCheckboxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports